import { render, staticRenderFns } from "./NotificationsDialog.vue?vue&type=template&id=0706cec2&"
import script from "./NotificationsDialog.vue?vue&type=script&lang=js&"
export * from "./NotificationsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports